import React from 'react';
import { matchPath } from 'react-router';

import AppContext from 'app/AppContext';
import { AuthorizerContext } from './AclProvider';

export default function useCanOpenPage() {
	const { routes } = React.useContext(AppContext);
	const authorizer = React.useContext(AuthorizerContext);

	const canOpenDetailsPage = React.useCallback(
		(module?: string, uid?: string) => {
			const to = `/${module?.replaceAll('_', '/')}/details/${uid}/summary`;

			const detailsRoute = routes
				.filter(route => route.path !== '*')
				.find(route => {
					// Removes last "?" from route path
					const routePath = route.path ? `/${route.path.replace(/\?$/, '')}` : '';
					return matchPath({ path: routePath }, to);
				});

			const canOpenLink = !!module && !!uid && !!detailsRoute && authorizer.can('view', module);

			return canOpenLink ? to : undefined;
		},
		[authorizer, routes]
	);

	return {
		canOpenDetailsPage
	};
}
